export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'e9adea23-0709-471b-a911-dd575e9eb144';
export const MODAL_CLOSE_SEC = 2.5;
